/**
 * LiveAnnouncer -- ARIA Live Region for Route Changes
 * Step 9F Green Phase -- Xyden Leadership Assessment Platform
 *
 * WCAG 4.1.3: Status messages can be programmatically determined.
 * Announces route changes and notifications to screen readers.
 */

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

/** Derive a human-friendly page title from the current pathname */
function pageTitleFromPath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return 'Home';

  // Use the last meaningful segment as the page name
  const lastSegment = segments[segments.length - 1];
  if (!lastSegment) return 'Page';

  // Convert kebab-case/path to title case
  return lastSegment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function LiveAnnouncer() {
  const location = useLocation();
  const [announcement, setAnnouncement] = useState('');

  useEffect(() => {
    const title = pageTitleFromPath(location.pathname);
    setAnnouncement(`Navigated to ${title}`);
  }, [location.pathname]);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {announcement}
    </div>
  );
}

export default LiveAnnouncer;
